import request from "root/js/request";

export const getPromotions = async ({ cabinet_id, is_upload }) => {
  const response = await request({
    url: `/analytics/promotion/?cabinet_id=${cabinet_id}`,
    params: {
      is_upload,
    },
    method: "get",
  });
  return response;
};
